import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    ADD_METHOD: "Добавить в очередь",
    RUN_METHOD: "Запустить метод",
    getConfirmRunText: (count) => `Вы уверены, что хотите запустить\r\n${count} ${buildCorrectGrammarText(count, [
        "задачу",
        "задачи",
        "задач"
    ])}?`
};
